import { render, staticRenderFns } from "./MyBrand.vue?vue&type=template&id=1f6fcd0f&scoped=true&"
import script from "./MyBrand.vue?vue&type=script&lang=js&"
export * from "./MyBrand.vue?vue&type=script&lang=js&"
import style0 from "./MyBrand.vue?vue&type=style&index=0&id=1f6fcd0f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6fcd0f",
  null
  
)

export default component.exports